import { render, staticRenderFns } from "./try-again.vue?vue&type=template&id=1f981e5c"
import script from "./try-again.vue?vue&type=script&lang=js"
export * from "./try-again.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports